
<template>
  <div class="leaps-energy">
    <div class="main-content" v-if="!isUserGroupAdmin">
      <search-leaps-energy @searchResult="filteredLeapsEnergyList"></search-leaps-energy>
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <leaps-energy-list v-if="showLeapsEnergyList" v-bind:leapsEnergyList="leapsEnergyList"></leaps-energy-list>
        </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <loader></loader>
      <div class="row margin-Top-3Perc">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <Copyright-Element class="footer"></Copyright-Element>
        </div>
      </div>   
    </div>
    <error-page v-if="isUserGroupAdmin"></error-page>  
  </div>
</template>

<script>
import AlertBox from '@/components/AlertOverlay'
import SearchLeapsEnergy from '@/components/leaps/energy/SearchLeapsEnergy'
import LeapsEnergyList from '@/components/leaps/energy/LeapsEnergyList'
import { leapsEnergyService } from '@/server-util/leaps-energy-service'
import CopyrightElement from '@/components/CopyrightElement' // copyright Menu
import { trackerService } from '@/server-util/tracker-service'
import { constants } from '@/utils/constants'
import ErrorPage from '@/pages/Error'
import Loader from '@/components/dashboard/Loader'
import { participantService } from '@/server-util/participant-service'
export default {
  created: function () {
    this.getLeapsEnergyList()
    this.trackPageLoad()
    this.checkUserErrorStatus()
  },
  data: function () {
    return {
      showLeapsEnergyList: false,
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      leapsEnergyList: []
    }
  },
  components: {
    'search-leaps-energy': SearchLeapsEnergy,
    'leaps-energy-list': LeapsEnergyList,
    'alert-box': AlertBox,
    'Copyright-Element': CopyrightElement,
    'error-page': ErrorPage,
    'loader': Loader
  },
  methods: {
    checkUserErrorStatus: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '') {
        participantService
          .getUserErrorStatus(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              const jsonObj = responseObj.data
              this.checkAndShowAlert(jsonObj)
            }
          }, errorObj => {
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            console.log('getUserErrorStatus Error :::' + this.errorMsg)
          })
      } else {
        console.log(
          'Access Token or required data is NULL hence declined LOADING GET ERROR INFO'
        )
      }
    },
    checkAndShowAlert: function (jsonObj) {
      if (jsonObj !== undefined && jsonObj !== 'undefined' && jsonObj !== null && jsonObj !== 'null' && jsonObj !== '') {
        const isLoggedOut = jsonObj.IsAdminLoggedOut
        const profileError = jsonObj.ProfileError
        if (isLoggedOut) {
          this.showAlertDialog = true
          this.errorMsg = constants.Logged_Out_From_Another_Platform_Error_Msg
        } else if (profileError === constants.Change_Password_Error_Profile) {
          this.showAlertDialog = true
          this.errorMsg = constants.Change_Password_Alert_Msg
        }
      }
    },
    peformCleanUpOperationOnSignOut: function () {
      var store = this.$store
      var cookies = this.$cookies
      cookies.remove(constants.LOGIN_COOKIE_KEY)
      cookies.remove(constants.LOGIN_USER_COOKIE)
      store.state.isUserProfileLoaded = false
      localStorage.removeItem(constants.LOGIN_USER_COOKIE)
      localStorage.setItem('selectedMenu', 0)
      localStorage.setItem('selectedSubMenu', 0)
      localStorage.clear()
      this.$store.state.curr_user = null
      this.$store.commit('resetState')
      this.$router.push('/')
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      switch (this.errorMsg) {
        case constants.Logged_Out_From_Another_Platform_Error_Msg:
          this.peformCleanUpOperationOnSignOut()
          break
        case constants.Change_Password_Alert_Msg:
          localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Settings)
          localStorage.setItem('selectedSubMenu', constants.SubMenuOptionsEnum.EditProfile)
          this.$router.push('/profile?OpenPopUp=true')
          break
      }
    },
    filteredLeapsEnergyList (value) {
      // AK: Use to show flitered list if they entered any word in Search
      this.leapsEnergyList = value
    },
    updateShowLeapListFlag: function (value) {
      // AK: Used to show list when server call completed
      this.showLeapsEnergyList = value
    },
    getLeapsEnergyList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        // AK: Check weather leapsEnergyList is already present or not?
        if (storeObj.state.leapsEnergyList.length === 0) {
          this.$store.state.isLoading = true
        } else {
          this.leapsEnergyList = storeObj.state.leapsEnergyList
          this.updateShowLeapListFlag(true)
        }
        leapsEnergyService
          .getLeapsEnergyList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.leapsEnergyList = responseObj.data
              if (this.$store.state.isLoading === true) {
                this.$store.state.isLoading = false
                this.updateShowLeapListFlag(true)
              }
              // AK: Show Leaps Energy List data initially when loaded (Without Filter)
              this.leapsEnergyList = responseObj.data
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING LEAPS ENERGY LIST'
        )
      }
    },
    trackPageLoad () {
      var store = this.$store
      var accessToken = store.state.access_token
      var userData = store.state.curr_user
      var userDataForActivity = 'UserName:{0}, FullName: {1}'
      userDataForActivity = userDataForActivity.replace('{0}', userData.UserName)
      userDataForActivity = userDataForActivity.replace('{1}', userData.FirstName + ' ' + userData.LastName)
      var trackingObj = {
        ActivityData: 'Load Leaps Energy Page, ' + userDataForActivity,
        ActivityType: constants.AdminActivityType.Manage_GroupCourseCohort,
        AdminAction: constants.AdminActionType.LoadScreen,
        ScreenName: 'MANAGE LEAPS ENERGY',
        UserRole: store.state.curr_user.AccountType,
        IsPrivate: false
      }
      trackerService.logActivity(accessToken, trackingObj).then(responseObj3 => {
        if (responseObj3.status === 200) {
          console.log('LOGGED ACTIVITY : ')
        }
      })
    }
  },
  computed: {
    isUserGroupAdmin: {
      get: function () {
        var userObj = this.$store.state.curr_user
        if (parseInt(userObj.AccountType) === parseInt(constants.UserAccountType.Group_Admin)) {
          return true
        } else {
          return false
        }
      }
    }
  },
  name: 'leaps-energy'
}
</script>

<style scoped>
.leaps-energy {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.left-color-border
{
	border: 1px solid red;
}
.right-color-border
{
	border: 1px solid green;
}
.leftNavBarBG
{
	background-color: #34495e;
  /*border:1px solid #34495e; */
}
.font-size-14px{
	font-size: 30px;
}
.position-Fixed
{
	position:fixed;
}
.float-Right
{
	float: right;
}
.fullHeight
{
	height:100% !important;
}
.fi-border
{
	border: 1px solid white;
}
 .footer-img
 {
    margin: 0 auto !important;
    display: block;
    position: absolute;
    bottom: 0;
	  width: 30%;
 }
 .center-block {
   margin-left:auto;
   margin-right:auto;
   display:block;
}
.text-center {
   text-align:center
}
.margin-Top-14Perc
{
	margin-top: 14%;
}
.margin-Top-1Perc
{
	margin-top: 1%;
}
.margin-Top-0Perc
{
  margin-Top:0%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}

.margin-Top-5Perc
{
	margin-top: 5%;
}
.admin-Panel-BG
{
  background-color: #f39c12;
}
.text-align-left
{
  text-align: left;
}
.margin-Left-4Perc
{
  margin-left: 4% !important;
}
.admin-Panel-Padding
{
  padding:0.1% 0% 0.1% 2%;
}
.font-size-2vw
{
  font-size: 2vw;
}
.margin-Top-3Perc{
  margin-top: 3% !important;
}
.footer{
    /* position: fixed; */
    left: 0 !important;
    bottom: 0 !important;
    width: 100% !important;
    /* background-color: red; */
    /* color: white; */
    text-align: center !important;
    margin-bottom: 1% !important;
    font-size: 12px !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/LeapsEnergy.vue